import { Editor } from '@tiptap/react';
import { normalizeTextColor } from 'shared/utils/richText';
import { Color } from 'shared/utils/colors';

const COMPLETE_HEX_COLOR = /^#[0-9a-f]{6}$/i;

/** A hex colour typed to its end (`#RRGGBB`), not one of its prefixes. */
export function isCompleteHexColor(value: string): boolean {
  return COMPLETE_HEX_COLOR.test(value);
}

/** The text colour at the selection, as `#RRGGBB`, or `undefined` when it has none. */
export function readSelectionTextColor(
  editor: Editor
): string | undefined {
  const { color } = editor.getAttributes('textStyle');
  return typeof color === 'string' ? normalizeTextColor(color) : undefined;
}

/** The colour the picker opens with: the selection's colour, else black. */
export function toPickerColor(color: string | undefined): string {
  return color ?? normalizeTextColor(Color.black) ?? '';
}

/** How many used colours are remembered. */
export const USED_TEXT_COLORS_LIMIT = 8;

/** The used colours after `color` was used: newest first, once each, at most `limit`. */
export function withUsedTextColor(
  used: readonly string[],
  color: string,
  limit = USED_TEXT_COLORS_LIMIT
): string[] {
  return [color, ...used.filter((usedColor) => usedColor !== color)].slice(
    0,
    limit
  );
}

/** The "recent" row of the menu: used colours that are not among the basic ones, which the menu shows anyway. */
export function recentCustomTextColors(
  used: readonly string[],
  basicColors: readonly string[]
): string[] {
  return used.filter((color) => !basicColors.includes(color));
}
